export const aboutMeContent = {
  profile: {
    name: "Leonardo P. Ferreira",
    title: "Freelancer Analista de Dados e de Business Intelligence",
    image: "/assets/minha-foto.jpg",
    tagline: "Transformando dados complexos em visualizações simples, intuitivas e estratégicas"
  },
  
  story: {
    introduction: "Olá, que esteja tudo bem! Me chamo Leonardo (ou Leo) e sou um jovem cearense formado em Finanças pela UFC. No entanto, desde o meu estágio em meados de 2022, descobri minhas habilidades e paixão por análise de dados, tendo largado tudo para virar freelancer no começo de 2023, onde utilizo as ferramentas do Google para criar soluções com planilhas e dashboards em minhas análises e projetos rotineiramente, com a graça e benção de Deus, apoio de minha família e confiança de meus clientes. Atuo há 3 anos como freelancer, transformando a complexidade dos dados em clareza estratégica. Minha missão é simples: garantir que cada decisão sua seja baseada em fatos, não em suposições.",
    
    mission: "Sou especialista no uso avançado de Google Sheets e Looker Studio, desenvolvendo dashboards e planilhas dinâmicas para áreas críticas como Marketing (Tráfego Pago), Comercial e Gestão de Clientes Recorrente (Assinaturas).",
    
    approach: "Sou movido pela entrega personalizada e por ir além. Meu aprendizado é contínuo — através de livros, cursos e notícias globais — para garantir que você receba sempre a solução mais atualizada e eficaz do mercado.",

    VisãoGlobal: "Com alto nível de proficiência em inglês, estou expandindo minha atuação para o mercado internacional, o que reforça meu compromisso com padrões globais de excelência e qualidade de entrega",
    
    values: [
      {
        title: "Orientado a Resultados",
        description: "Cada projeto é medido pelo impacto nos negócios, não apenas pelas entregas técnicas."
      },
      {
        title: "Comunicação Transparente",
        description: "Explicações claras e sem jargões. Você sempre saberá o que está sendo construindo e por quê."
      },
      {
        title: "Aprendizado Contínuo",
        description: "O cenário de dados evolui rapidamente. Mantenho-me atualizado com as ferramentas e metodologias mais recentes."
      }
    ]
  },
  
  skills: [
    { name: "Business Intelligence", category: "analytics" },
    { name: "Visualização de Dados", category: "analytics" },
    { name: "Google Sheets", category: "tools" },
    { name: "Google Looker Studio", category: "tools" },
    { name: "Google App Script", category: "tools" },
    { name: "Google Forms", category: "tools" },
    { name: "Análise & Previsão Estatística", category: "analytics" },
  ],
  
  certifications: [
    "Google Looker Studio",
    "Google Sheets",
    "Google Analytics 4",
    "Google e Meta Ads"
  ],
  
  socialLinks: [
    { platform: "LinkedIn", url: "https://www.linkedin.com/in/leonardo-p-ferreira", icon: "linkedin" },
    { platform: "Instagram", url: "https://instagram.com/lpfdataanalytics", icon: "instagram" },
    { platform: "YouTube", url: "https://www.youtube.com/@lpfdataanalytics", icon: "youtube" },
    { platform: "Workana", url: "https://www.workana.com/freelancer/09b83457c4c3b37edb4f0f1d4a4a7d91", icon: "workana" },
    { platform: "Upwork", url: "http://bit.ly/leonardoupwork", icon: "upwork" },
    { platform: "Drive", url: "https://drive.google.com/drive/folders/1FBHeAjmGZWAKhkw4bt4r64QXB1Z0Uusz?usp=drive_link", icon: "drive" },
    { platform: "Email", url: "mailto:lpfdataanalytics@gmail.com", icon: "mail" }
  ],
  
  stats: [
    { label: "Anos de Experiência", value: "3+" },
    { label: "Projetos Completos", value: "230+" },
    { label: "Clientes Satisfeitos", value: "120+" },
  ]
};
